import { defineMessages } from 'react-intl';

export default defineMessages({
  saveContextError: {
    id: 'authenticator.onboarding.activities.saveContextError',
    defaultMessage: 'Error on saving your configuration',
  },
});
